import React, { FC } from 'react';
import {
	DashboardPerformerNames,
	DashboardPerformerSkeleton,
	useUrlParams,
} from '@aleph/shared-components';
import { DashboardStatsQuery } from 'wb-reddit/graphql/generated';
import { RedditLevel, RedditLevelId } from 'wb-reddit/app/routes/superGrid/utils';
import classNames from 'classnames';
import { useNavigate, useParams } from 'react-router-dom';

type NameCellPerformersParams = {
	selectedKPI: string | null
	performersType: 'bestPerformers' | 'worstPerformers'
	loading?: boolean
	performers?: DashboardStatsQuery['bestPerformers']['items'] | DashboardStatsQuery['worstPerformers']['items']
};

// TODO translate
const bestPerformerPlaceholders = ['Top best performer', '2nd best performer', '3rd best performer'];
const worstPerformersPlaceholders = ['3rd worst performer', '2nd worst performer', 'The worst performer'];

const NameCellPerformers: FC<NameCellPerformersParams> = ({
	selectedKPI,
	performersType,
	loading,
	performers,
}) => {
	const navigate = useNavigate();

	const { setUrlParams, params: urlParams } = useUrlParams({ navigate, useParams });

	const omitViewToBreakdown = (id: string) => {
		setUrlParams({
			...urlParams,
			filters: {
				[RedditLevelId[RedditLevel.CAMPAIGN]]: [{ value: [id] }],
			},
			level: RedditLevel.GROUP,
		});
	};

	if (!selectedKPI) {
		return (
			<>
				{new Array(3).fill(null).map((_, idx) => (
					<div key={idx}
						className="flex h-[32px] justify-between border-dashed border-b-[1px]"
					>
						<div
							className={classNames('flex items-center pl-[12px] w-full text-[12px] hover:text-blue')}
						>
							<div className="whitespace-nowrap overflow-hidden overflow-ellipsis text-gray-600">
								{
									performersType === 'bestPerformers'
										? bestPerformerPlaceholders[idx]
										: worstPerformersPlaceholders[idx]
								}
							</div>
						</div>
						<div className={classNames('flex items-center text-[12px] font-semibold pr-[12px]', {
							'text-green': performersType === 'bestPerformers',
							'text-red':   performersType === 'worstPerformers',
						})}
						>
							{`${performersType === 'bestPerformers' ? '+' : '-'}%`}
						</div>
					</div>
				))}
			</>
		);
	}

	return (
		<div className="w-full h-[96px]">
			{loading && <DashboardPerformerSkeleton />}

			{
				performers
				&& <DashboardPerformerNames
					<DashboardStatsQuery['bestPerformers']['items'] | DashboardStatsQuery['worstPerformers']['items']>
					data={performers}
					selectedKpi={selectedKPI}
					onPerformerClick={performer => omitViewToBreakdown(performer.id)}
				/>
			}
		</div>
	);
};

export default NameCellPerformers;
